<div class="choose-flight">
  <div class="title-row">
    <h5 class="title">Escolha um <strong>voo de {{ direction.value }}</strong></h5>
    <div class="toggle-direct-flights">
      <span class="toggle-label">Voos Diretos</span>
      <mat-slide-toggle [(ngModel)]="filterDirectOnly" (change)="onDirectFlightsToggle()"
        color="primary">
      </mat-slide-toggle>
    </div>
  </div>

  <div class="panel">
    <div class="flight-data">
      @if (direction === Direction.OUTBOUND) {
        <span class="panel_route">{{ flightsFormData.airportOrigin }} > {{ flightsFormData.airportDestiny }}</span>
        <span class="panel_day">
          {{ flightsFormData.dtDeparture | dateFormat: 'DD/MM/YYYY' }}
        </span>
      } @else {
        <span class="panel_route">{{ flightsFormData.airportDestiny }} > {{ flightsFormData.airportOrigin }}</span>
        <span class="panel_day">
          {{ flightsFormData.dtArrival | dateFormat: 'DD/MM/YYYY' }}
        </span>
      }


    </div>

    <div #panelArrow class="collapse-flights_arrow" (click)="toggleCollapseFlights()"></div>
  </div>

  <div #panelBody class="collapse-flights_body">
    <div class="flights">
      @for (option of filteredFlights; track option; let i = $index) {
        <div class="flight-container">
          <div class="flight-selection_container">
            <div class="flight-checkbox">
              <mat-checkbox color="primary"
                (change)="selectCheckbox($event, option)"
                [checked]="checked(option)"
                [disabled]="isCheckboxDisabled(option)">
              </mat-checkbox>
            </div>
            <div class="card-flight">
              <ng-container>
                <app-card-flight [flight]="option" [position]="i"
                  [isMultiple]="option.flightSegments.length > 1"
                  (toggle)="toggleItinerary($event)">
                </app-card-flight>
              </ng-container>
            </div>
          </div>
          <div class="card-itinerary" id="card-itinerary-{{direction.name}}-{{i}}">
            @if (option.flightSegments.length > 1) {
              <app-card-itinerary-flight-two [flight]="option"></app-card-itinerary-flight-two>
            } @else {
              <app-card-itinerary-flight [flight]="option"></app-card-itinerary-flight>
            }
          </div>
        </div>
      }
    </div>
  </div>

  @if (proceeded && form.controls[direction.name].errors?.required) {
    <app-error-form>
      Escolha o voo de {{ direction.value }}.
    </app-error-form>
  }
</div>

